import { render, staticRenderFns } from "./Zuordnung.vue?vue&type=template&id=f4cf2436&scoped=true&"
import script from "./Zuordnung.vue?vue&type=script&lang=js&"
export * from "./Zuordnung.vue?vue&type=script&lang=js&"
import style0 from "./Zuordnung.vue?vue&type=style&index=0&id=f4cf2436&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../home/zarzar/Documents/public-solution/bis-office/web/zeitkontrolle/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f4cf2436",
  null
  
)

export default component.exports